<template>
<div
    v-if="bulk_message != null"
>

    <h2
        style="margin-bottom: 15px"
    >
        Before Sending
    </h2>

    <m-edit-text
        :label="bulk_message.filter_profile.before_send_add_list_ids.label"
        :value="bulk_message.filter_profile.before_send_add_list_ids.value_description"
        :custom_on_edit="onEditBeforeSendAddLists"
        :read_only="has_sent"
        v-show="bulk_message.filter_profile.before_send_add_list_ids.visible"
        style="margin-left: 15px"
    />

    <h2
        style="margin-bottom: 15px"
    >
        Filters
    </h2>

    <p><b>Filter by other messages</b></p>
    

    <m-edit-text
        :label="bulk_message.filter_profile.filter_days_since_last_bulk_message.label"
        :value="bulk_message.filter_profile.filter_days_since_last_bulk_message.value_description"
        :custom_on_edit="onEditFilterDaysSince"
        :read_only="has_sent"
        v-show="bulk_message.filter_profile.filter_days_since_last_bulk_message.visible"
        style="margin-left: 15px"
    />

    <m-edit-text
        :label="bulk_message.filter_profile.filter_recipients_in_other_bulk_messages.label"
        :value="bulk_message.filter_profile.filter_recipients_in_other_bulk_messages.value_description"
        :custom_on_edit="onEditFilterOtherBulkMessages"
        :read_only="has_sent"
        v-show="bulk_message.filter_profile.filter_recipients_in_other_bulk_messages.visible"
        style="margin-left: 15px"
    />

    <p><b>Filter by time and location</b></p>

     <p 
        v-show="bulk_message.filter_profile.filter_send_time.visible"
        style="margin-left: 15px"
    >
        <a v-on:click="onClickViewTimeRestrictions()" style="text-decoration: underline">Click here for more state by state details</a>
    </p>

    <m-edit-text
        :label="bulk_message.filter_profile.filter_send_time.label"
        :value="bulk_message.filter_profile.filter_send_time.value_description"
        :custom_on_edit="onEditFilterSendTime"
        :read_only="has_sent"
        v-show="bulk_message.filter_profile.filter_send_time.visible"
        style="margin-left: 15px"
    />

    <m-edit-text
        :label="bulk_message.filter_profile.filter_simple_do_not_send_after_wall_time.label"
        :value="bulk_message.filter_profile.filter_simple_do_not_send_after_wall_time.value_description"
        :custom_on_edit="onEditFilterSimpleDoNotSendAfter"
        :read_only="has_sent"
        v-show="bulk_message.filter_profile.filter_simple_do_not_send_after_wall_time.visible"
        style="margin-left: 15px"
    />

    <m-edit-wall-time-dialog
        :title="bulk_message.filter_profile.filter_simple_do_not_send_after_wall_time.label"
        :value="bulk_message.filter_simple_do_not_send_after_wall_time"
        ref="edit-simple-send-after-dialog"
        :optional="true"
        unset_label="Do not use this filter"
        v-on:ok="onSetSimpleDoNotSendAfterFilter"
    />
    
    <p><b>Filter by consent and/or purchase history*</b></p>

    <m-edit-text
        :label="bulk_message.filter_profile.filter_order_history.label"
        :value="bulk_message.filter_profile.filter_order_history.value_description"
        :custom_on_edit="onEditFilterOrderHistory"
        :read_only="has_sent"
        v-show="bulk_message.filter_profile.filter_order_history.visible"
        style="margin-left: 15px"
    />

    <m-edit-text
        :label="bulk_message.filter_profile.filter_consent.label"
        :value="bulk_message.filter_profile.filter_consent.value_description"
        :custom_on_edit="onEditFilterConsent"
        :read_only="has_sent"
        v-show="bulk_message.filter_profile.filter_consent.visible"
        style="margin-left: 15px"
    />

    <p
        style="margin-left: 15px; font-size: 12px; margin-top: 7px;"
    >
        * &mdash; RedChirp automatically tries to avoid sending bulk messages to recipients who have opted out, and to recipients who appear in tcpalitigatorlist.com (which advertises itself as a database of known TCPA litigators, TCPA trolls, and DNC Complainers) 
    </p>

    <a v-on:click="onClickTechnicalDetails">
        Technical Details
    </a>

    

</div>
</template>

<script>
export default {
    props: {
        bulk_message: {
            type: Object,
            default: function() { return null; }
        },
    },

    methods: {
        onEditFilterOrderHistory()
        {
            this.$rc.prompt({
                    'title' : 'Order history filter settings',
                    'label' : 'Only send to recipients who have consent on file in RedChirp OR have purchased within the last (number of months)',
                    'value' : this.bulk_message.filter_order_history,
                    'unset_label': 'Do not use this filter',
                    'is_valid': this.$rc.validationRuleInteger(1,null),
                    'after_prompt' : (value) => {
                        
                        this.$emit(
                            'patch',
                            {
                                'filter_order_history': value,
                            },
                        );

                    }
                });
        },

        onEditFilterDaysSince() {
            
            this.$rc.prompt({
                    'title' : 'Recent bulk message filter settings',
                    'label' : this.bulk_message.filter_profile.filter_days_since_last_bulk_message.label,
                    'value' : this.bulk_message.filter_days_since_last_bulk_message,
                    'unset_label': 'Do not use this filter',
                    'is_valid': this.$rc.validationRuleInteger(1,null),
                    'after_prompt' : (value) => {
                        
                        this.$emit(
                            'patch',
                            {
                                'filter_days_since_last_bulk_message': value,
                            },
                        );

                    }
                });
        },

        onEditFilterOtherBulkMessages()
        {
            this.$rc.pick({
                'title': 'Do not send to recipients of other bulk message(s) filter settings',
                'content_before': '',
                'content_after': null,
            
                'choices': [],
            
                'multiple': true,
                'type': 'select_object_type',
                'select_object_type': 'bulk_message',
                'select_label': this.bulk_message.filter_profile.filter_recipients_in_other_bulk_messages.label,
                'initial_value': this.bulk_message.filter_recipients_in_other_bulk_messages,
                'unset_label': 'Do not use this fitler',
            
                'on_ok': (value) => {

                    if ( value == null ) 
                        value = [];
                    
                    
                    this.$emit(
                            'patch',
                            {
                                'filter_recipients_in_other_bulk_messages': value,
                            },
                        );
                },
            
                'on_cancel': () => {}
            
            });
        },

        onEditBeforeSendAddLists()
        {
            this.$rc.pick({
                'title': 'Before sending, make sure that every member of the following list(s) is a recipient of this message',
                'content_before': '',
                'content_after': null,
            
                'choices': [],
            
                'multiple': true,
                'type': 'select_object_type',
                'select_object_type': 'lists',
                'select_label': this.bulk_message.filter_profile.before_send_add_list_ids.label,
                'initial_value': this.bulk_message.before_send_add_list_ids,
                'unset_label': 'Do not use this before send action',
            
                'on_ok': (value) => {

                    if ( value == null ) 
                        value = [];
                    
                    
                    this.$emit(
                            'patch',
                            {
                                'before_send_add_list_ids': value,
                            },
                        );
                },
            
                'on_cancel': () => {}
            
            });
        },

        onEditFilterSimpleDoNotSendAfter()
        {
            this.$refs['edit-simple-send-after-dialog'].showDialog();
        },

        onSetSimpleDoNotSendAfterFilter(value)
        {
            this.$emit(
                'patch',
                {
                    'filter_simple_do_not_send_after_wall_time': value,
                },
            );
        },

        onEditFilterConsent()
        {
            

            this.$rc.pick({
                'title': 'Consent filter settings',
                'content_before': '',
                'content_after': null,
            
                'choices': this.$rc.enumValues('consent_filter_type', false),
            
                'multiple': false,
                'type': 'select',
                'select_label': 'Choose One',
                'initial_value': this.filter_consent ?? 'none',
                'unset_label': 'Do not use this filter',
            
                'on_ok': (value) => {
                    if ( value == null ) value = 'none';

                    this.$emit(
                            'patch',
                            {
                                'filter_consent': value,
                            },
                        );
                },
            
                'on_cancel': () => {}
            
            });
        },

        onEditFilterSendTime()
        {
            this.$rc.pick({
                'title': this.bulk_message.filter_profile.filter_send_time.label+' filter settings',
                'content_before': '',
                'content_after': null,
            
                'choices': this.$rc.enumValues('send_time_filter_type', false),
            
                'multiple': false,
                'type': 'select',
                'select_label': this.bulk_message.filter_profile.filter_send_time.label,
                'initial_value': this.bulk_message.filter_send_time ?? 'none',
                'unset_label': 'Do not use this filter',
            
                'on_ok': (value) => {
                    if ( value == null ) value = 'none';

                    this.$emit(
                            'patch',
                            {
                                'filter_send_time': value,
                            },
                        );
                },
            
                'on_cancel': () => {}
            
            });
        },
        

        onClickViewTimeRestrictions()
        {
            window.open(this.$router.resolve({
                'name': 'public-restricted-messaging-times',
                'params' : {
                }
            }).href, '_blank');
        },

        onClickTechnicalDetails()
        {
            this.$rc.technicalDetails({
                'title': 'Filter Technical Details',
                'technical_details': this.bulk_message.filter_profile.technical_details,
            });
        },
    },

    computed: {
        has_sent() {
            if ( this.bulk_message == null ) return false;
            return this.bulk_message.sent_time != null;
        }
    },
}
</script>

<style lang="scss" scoped>

</style>